/**
 * Actions for the GlobalLoading component
 * Contains action creators that dispatch Redux actions to control loading state
 */
import { store } from '../../redux/store';
import { startGlobalLoading, finishGlobalLoading } from './reducer';

/**
 * Shows the global loading overlay
 * Dispatches the startGlobalLoading action to the Redux store
 */
export const startLoading = () => {
  store.dispatch(startGlobalLoading());
};

/**
 * Hides the global loading overlay
 * Dispatches the finishGlobalLoading action to the Redux store
 */
export const finishLoading = () => {
  store.dispatch(finishGlobalLoading());
};
